import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { BellIcon, EnvelopeIcon, TrashIcon } from '@heroicons/react/24/outline';
import { Whatsapp } from 'react-bootstrap-icons';

const SendWhatsAppNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define edge labels
  const edgeLabels = ['On Send', 'On Delivery', 'On Failure', 'On Read', 'On Click'];

  // Define color schemes based on source
  const colorScheme = {
    seller: {
      border: 'border-green-400',
      rounded: 'rounded-full',
      gradient: 'from-green-50 to-green-100',
      borderBottom: 'border-green-300',
      text: 'text-green-700',
      handle: 'border-2 border-green-400 !bg-green-400 hover:!bg-green-50'
    },
    manager: {
      border: 'border-purple-400',
      rounded: 'rounded-full',
      gradient: 'from-purple-50 to-purple-100',
      borderBottom: 'border-purple-300',
      text: 'text-purple-700',
      handle: 'border-2 border-purple-400 !bg-purple-400 hover:!bg-purple-50'
    },
    actions: {
      border: 'border-green-200',
      rounded: 'rounded-lg',
      gradient: 'from-green-50 to-green-100',
      borderBottom: 'border-green-200',
      text: 'text-green-700',
      handle: 'border-2 border-green-400 !bg-green-400 hover:!bg-green-50'
    }
  };

  const colors = colorScheme[data.source || 'actions'];

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`bg-white p-2 ${colors.rounded} shadow-lg border-2 ${colors.border} relative`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >

      {/* Updated delete button with hover visibility */}
      <div 
        className={`absolute ${data.source === 'seller' || data.source === 'manager' ? '-right-2 -top-2' : '-top-3 left-1/2 -translate-x-1/2'} 
          w-5 h-5 bg-gray-200 rounded-full flex items-center justify-center cursor-pointer 
          hover:bg-gray-600 hover:text-white z-10 transition-opacity duration-200 
          ${isHovered ? 'opacity-100' : 'opacity-0'}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <TrashIcon className='w-4 h-4 p-0.5 hover:text-white text-black'/>
      </div>

      <div className={`p-3 py-5 bg-gradient-to-r ${colors.gradient} border-b ${colors.borderBottom} ${colors.rounded}`}>
        <div className="flex items-center gap-2">
          <Whatsapp className={`w-8 h-8 p-1.5 bg-white ${colors.text} rounded-full`}/>
          <span className={`font-semibold ${colors.text}`}>Send WhatsApp Message</span>
          {data?.label?.length > 0 &&<span className="font-semibold text-green-700">- {data.label}</span>}
        </div>
      </div>

      {(data.source === 'seller' || data.source === 'manager') ? (
        <>
          <Handle
            type="target"
            position={Position.Top}
            className={`w-4 h-4 ${colors.handle}`}
          />
          {data.source !== 'manager' ? <Handle
            type="source"
            position={Position.Bottom}
            className={`w-4 h-4 ${colors.handle}`}
          /> : null}
        </>
      ) : (
        <>
          <Handle
            type="target"
            position={Position.Left}
            className={`w-4 h-4 ${colors.handle}`}
          />
          <div className="absolute right-0 top-1/2 -translate-y-1/2 h-[70px]">
            {Array.from({ length: outputEdges }).map((_, index) => (
              <div 
                key={`output-${index}`} 
                className="relative w-full"
                style={{
                  top: `${(index * 100) / (outputEdges - 1)}%`,
                  transform: 'translateY(-50%)'
                }}
              >
                <Handle
                  type="source"
                  position={Position.Right}
                  id={`output-${index}`}
                  className={`w-4 h-4 ${colors.handle}`}
                />
                <div 
                  className={`absolute w-max text-[10px] bg-white pr-3 ${colors.text} transition-opacity duration-200 ${isHovered ? 'opacity-100' : 'opacity-0'}`}
                  style={{
                    left: '5px',
                    top: '-7.5px',
                  }}
                >
                  {edgeLabels[index]}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SendWhatsAppNode; 
